import { render } from "./whyCoaching.vue?vue&type=template&id=882a8b50&scoped=true"
import script from "./whyCoaching.vue?vue&type=script&lang=js"
export * from "./whyCoaching.vue?vue&type=script&lang=js"

import "./whyCoaching.vue?vue&type=style&index=0&id=882a8b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882a8b50"]])

export default __exports__